import Empty from '@/components/Empty.vue'
import book from '@/components/yachts_book.vue'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import PayType from '@/views/Home/PayType'
import 'swiper/css/swiper.min.css'
const mixin = {
    name: 'HomeView',
    components: {
        swiper,
        swiperSlide,
        book,
        Empty,
        PayType,
        'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
    },
    data() {
        return {
            swiperOption: {
                spaceBetween: 30,
                effect: 'fade',
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    bulletActiveClass: 'my-bullet-active',
                    bulletClass: 'my-bullet', //需设置.my-bullet样式
                },
                autoplay: {
                    delay: 3000,
                },
            },
            swiperOption2: {
                spaceBetween: 30,
                effect: 'fade',
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    bulletActiveClass: 'my-bullet-active',
                    bulletClass: 'my-bullet', //需设置.my-bullet样式
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                lazy: {
                    loadPrevNext: false,
                },
            },
            weekCh: ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
            yachts_lists: [],
            bannerImgs: [
                require('@/assets/banner_r1.png'),
                require('@/assets/banner_r2.png'),
                require('@/assets/banner_r3.png'),
                require('@/assets/banner_r4.png'),
            ],
            map_imgs: [
                require('@/assets/video/video1.mp4'),
                require('@/assets/video/video2.mp4'),
                require('@/assets/video/video3.mp4'),
            ],
            map_imgss: require('@/assets/video/video1.mp4'),
            map_cover: require('@/assets/map_cover1.png'),
            map_covers: [
                require('@/assets/map_cover1.png'),
                require('@/assets/map_cover2.png'),
                require('@/assets/map_cover3.png'),
            ],
            swiperOptions: {
                // loop: true,
                speed: 2000,
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
                effect: 'fade',
                // 显示分页
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true, //允许分页点击跳转
                },
                // 设置点击箭头
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            },
            list: {
                select_dates: '',
                charter_hours: 1,
                charter_time: 0,
                number_guests: 0,
            },
            active: '',
            yachts_book: false,
            books: {},
            marks: {
                // 0: '',
                // 1: '',
                // 2: '',
                // 3: '',
                // 4: '',
                // 5: '',
                6: '6AM',
                7: '',
                8: '',
                9: '',
                10: '',
                11: '',
                12: '',
                13: '',
                14: '',
                15: '',
                16: '',
                17: '',
                18: '',
                19: '',
                20: '',
                21: '',
                22: '',
                23: '',
                // 24: '12PM',
            },
            values: '6AM',
            walk_img: false,
            tomorrow: new Date(),
            // 默认选择日期
            pickerOptionsDate: {
                disabledDate: time => {
                    let yesterday = new Date()
                    yesterday.setTime(yesterday.getTime() - 24 * 60 * 60 * 1000)
                    return time.getTime() < yesterday
                },
            },
            lazyBox: '',
            showImage: false,
            urlList: [],
            imgIndex: 0,
        }
    },
    watch: {
        value(newValue) {
            this.list.number_guests = newValue
        },
        'list.charter_time'() {
            if (this.list.charter_time < 12) {
                this.values = this.list.charter_time + 'AM'
            } else if (this.list.charter_time == 12) {
                this.values = '12AM'
            } else if (this.list.charter_time == 24) {
                this.values = '12PM'
            } else {
                this.values = this.list.charter_time - 12 + 'PM'
            }
        },
    },
    computed: {
        map_address() {
            return [this.$t('map_address1'), this.$t('map_address2'), this.$t('map_address3')]
        },
        map_buttons() {
            return [this.$t('map_hour1'), this.$t('map_hour2'), this.$t('map_hour3')]
        },
        styles() {
            const length = 18,
                progress = this.list.charter_time,
                left = ((progress - 6) / length) * 100
            return {
                paddingLeft: `${left}%`,
            }
        },
        style() {
            const length = 45,
                progress = this.list.number_guests,
                left = (progress / length) * 90
            return {
                paddingLeft: `${left}%`,
            }
        },
    },
    async created() {
        //明天的时间
        this.tomorrow.setTime(this.tomorrow.getTime() + 24 * 60 * 60 * 1000)
        this.setLocValue({ date: this.dayjs(this.tomorrow).format('YYYY-MM-DD') })
        await this.$store.dispatch('home/getRentalYachtsList', {
            rentDate: this.dayjs(this.tomorrow).format('YYYY-MM-DD'),
            beginTime: '6:00',
        })
        this.yachts_lists = this.$store.state.home.yacthsList
    },
    mounted() {
        this.$nextTick(() => {
            let that = this
            this.$refs['walk'].addEventListener('ended', function (e) {
                that.walk_img = true
            })
            this.lazyBox = document.getElementById('app')
        })
    },
    methods: {
        async selecDate() {
            // 筛选游艇列表
            let params = {
                rentDate: this.dayjs(this.list.select_dates).format('YYYY-MM-DD'),
            }
            if (this.list.charter_time) {
                params['beginTime'] =
                    (+this.list.charter_time > 9 ? this.list.charter_time : '0' + this.list.charter_time) + ':00'
            }
            this.list.charter_hours = params['rentHours'] = this.list.charter_hours
            if (this.list.number_guests) {
                params['passengerNum'] = this.list.number_guests
            }
            this.setLocValue({
                date: this.dayjs(this.list.select_dates).format('YYYY-MM-DD'),
            })
            await this.$store.dispatch('home/getRentalYachtsList', params)
            this.yachts_lists = this.$store.state.home.yacthsList
        },
        async numberGuests() {
            // 筛选游艇列表
            let params = {}
            if (!this.list.select_dates) {
                params['rentDate'] = this.dayjs(this.tomorrow).format('YYYY-MM-DD')
            }
            if (this.list.select_dates) {
                params['rentDate'] = this.dayjs(this.list.select_dates).format('YYYY-MM-DD')
            }
            if (this.list.charter_time) {
                params['beginTime'] =
                    (+this.list.charter_time > 9 ? this.list.charter_time : '0' + this.list.charter_time) + ':00'
            }
            this.list.charter_hours = params['rentHours'] = this.list.charter_hours
            if (this.list.number_guests) {
                params['passengerNum'] = this.list.number_guests
            }
            this.setLocValue({ person: this.list.number_guests })
            await this.$store.dispatch('home/getRentalYachtsList', params)
            this.yachts_lists = this.$store.state.home.yacthsList
        },
        // 本地存储筛选信息
        setLocValue(params) {
            // 本地存储用户信息
            this.$store.commit('home/getUserOrderInfo', {
                ...this.$store.state.home.userOrderInfo,
                ...params,
            })
        },
        async timeTip() {
            if (this.list.charter_time < 12) {
                this.values = this.list.charter_time + 'AM'
            } else if (this.list.charter_time == 12) {
                this.values = '12AM'
            } else if (this.list.charter_time == 24) {
                this.values = '12PM'
            } else {
                this.values = this.list.charter_time - 12 + 'PM'
            }
            this.setLocValue({
                time: this.list.charter_time + ':00',
                // timeValue: this.list.charter_time,
            })
            // 筛选游艇列表
            let params = {}
            if (!this.list.select_dates) {
                params['rentDate'] = this.dayjs(this.tomorrow).format('YYYY-MM-DD')
            }
            if (this.list.select_dates) {
                params['rentDate'] = this.dayjs(this.list.select_dates).format('YYYY-MM-DD')
            }
            params['beginTime'] =
                (+this.list.charter_time > 9 ? this.list.charter_time : '0' + this.list.charter_time) + ':00'
            this.list.charter_hours = params['rentHours'] = this.list.charter_hours
            if (this.list.number_guests) {
                params['passengerNum'] = this.list.number_guests
            }
            this.setLocValue({ person: this.list.number_guests })
            await this.$store.dispatch('home/getRentalYachtsList', params)
            this.yachts_lists = this.$store.state.home.yacthsList
        },
        async hour_up() {
            if (this.list.charter_hours < 24) {
                this.list.charter_hours++
                // 筛选游艇列表
                let params = {}
                if (!this.list.select_dates) {
                    params['rentDate'] = this.dayjs(this.tomorrow).format('YYYY-MM-DD')
                }
                if (this.list.select_dates) {
                    params['rentDate'] = this.dayjs(this.list.select_dates).format('YYYY-MM-DD')
                }
                params['beginTime'] =
                    (+this.list.charter_time > 9 ? this.list.charter_time : '0' + this.list.charter_time) + ':00'
                this.list.charter_hours = params['rentHours'] = this.list.charter_hours
                if (this.list.number_guests) {
                    params['passengerNum'] = this.list.number_guests
                }
                this.setLocValue({ person: this.list.number_guests })
                await this.$store.dispatch('home/getRentalYachtsList', params)
                this.yachts_lists = this.$store.state.home.yacthsList
            } else {
                this.list.charter_hours = this.list.charter_hours
            }
            this.setLocValue({ hour: this.list.charter_hours })
        },
        async hour_down() {
            if (this.list.charter_hours > 1) {
                this.list.charter_hours--
                // 筛选游艇列表
                let params = {}
                if (!this.list.select_dates) {
                    params['rentDate'] = this.dayjs(this.tomorrow).format('YYYY-MM-DD')
                }
                if (this.list.select_dates) {
                    params['rentDate'] = this.dayjs(this.list.select_dates).format('YYYY-MM-DD')
                }
                params['beginTime'] =
                    (+this.list.charter_time > 9 ? this.list.charter_time : '0' + this.list.charter_time) + ':00'
                this.list.charter_hours = params['rentHours'] = this.list.charter_hours
                if (this.list.number_guests) {
                    params['passengerNum'] = this.list.number_guests
                }
                this.setLocValue({ person: this.list.number_guests })
                await this.$store.dispatch('home/getRentalYachtsList', params)
                this.yachts_lists = this.$store.state.home.yacthsList
            } else {
                this.list.charter_hours = this.list.charter_hours
            }
            this.setLocValue({ hour: this.list.charter_hours })
        },
        proceed_sub(data) {
            this.setLocValue(data)
            this.$router.push(`/${this.$i18n.locale}/bookOrder`)
        },
        // 提交申请
        apply() {
            // console.log(this.list)
        },
        book(res) {
            this.books = res
            this.setLocValue(res)
            this.yachts_book = true
        },
        clickBtn(e) {
            // this.$refs.carousel.setActiveItem(e)
            this.active = e
            this.map_imgss = this.map_imgs[e]
            this.map_cover = this.map_covers[e]
        },
        imageShow(list, index, e) {
            if (e.target.getAttribute('lazy') === 'error') return
            this.showImage = true
            this.urlList = list
            this.imgIndex = index
            const m = e => {
                e.preventDefault()
            }
            document.body.style.overflow = 'hidden'
            document.addEventListener('touchmove', m, false) // 禁止页面滑动
        },
        closeImage() {
            this.showImage = false
            const m = e => {
                e.preventDefault()
            }
            document.body.style.overflow = 'auto'
            document.removeEventListener('touchmove', m, true)
        },
        imgError(e) {
            e.target.setAttribute('src', require('@/assets/lazy-img.png'))
            e.target.setAttribute('lazy', 'error')
        },
    },
}
export default mixin
